import { CpsBadge } from "corpus";
import { graphql } from "@repo/graphql-types";
import { useGraphQL } from "@/hooks/use-graphql";
import type { AssistFeatures } from "@/enums/assist-features";
import { AsyncDataWrapper } from "@/components/async-data-wrapper";

const DashboardFeatureStatusBadgeQuery = graphql(`
  query DashboardFeatureStatusBadgeQuery {
    funcionalidadesDesativadas {
      codFuncionalidade
    }
  }
`);

interface DashboardFeatureStatusBadgeProps {
  featureId: AssistFeatures;
}

export const DashboardFeatureStatusBadge = ({
  featureId,
}: DashboardFeatureStatusBadgeProps): JSX.Element => {
  const queryResult = useGraphQL(DashboardFeatureStatusBadgeQuery);

  const { data } = queryResult;

  const isFeatureDisabled = data?.funcionalidadesDesativadas.some(
    (feature) => feature.codFuncionalidade === featureId.valueOf(),
  );

  return (
    <AsyncDataWrapper {...queryResult}>
      <CpsBadge color={isFeatureDisabled ? "neutral" : "success"} shade="light">
        {isFeatureDisabled ? "Desativado" : "Ativado"}
      </CpsBadge>
    </AsyncDataWrapper>
  );
};
